/**
 * Utility functions to manage Terms of Use acceptance cookie
 */

const COOKIE_NAME = 'termsOfUseAcceptance';

/**
 * Get the current date in YYYY-MM-DD format (local timezone)
 */
const getTodayDate = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

/**
 * Set the Terms of Use acceptance cookie with today's date
 */
export const setTermsOfUseAcceptance = (): void => {
    const today = getTodayDate();
    const isSecure = window.location.protocol === 'https:';
    const secureFlag = isSecure ? '; Secure' : '';
    
    document.cookie = `${COOKIE_NAME}=${today}; path=/; SameSite=Lax${secureFlag}`;
};

/**
 * Get the Terms of Use acceptance date from cookie
 * @returns The acceptance date string (YYYY-MM-DD) or null if not found
 */
export const getTermsOfUseAcceptance = (): string | null => {
    const cookies = document.cookie.split(';');
    
    for (const cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === COOKIE_NAME) {
            return value;
        }
    }
    
    return null;
};

/**
 * Check if the user has accepted the Terms of Use today
 * @returns true if the user has accepted today, false otherwise
 */
export const hasAcceptedTermsToday = (): boolean => {
    const acceptanceDate = getTermsOfUseAcceptance();
    
    if (!acceptanceDate) {
        return false;
    }
    
    const today = getTodayDate();
    return acceptanceDate === today;
};

/**
 * Clear the Terms of Use acceptance cookie
 */
export const clearTermsOfUseAcceptance = (): void => {
    const isSecure = window.location.protocol === 'https:';
    const secureFlag = isSecure ? '; Secure' : '';
    document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax${secureFlag}`;
};
